<template>
  <article v-scroll:reveal class="layout-section -bg-image -align-center">
    <section class="layout-section__bg-image" style="background-image: url('/images/background.jpg');">
      <h4 v-scroll:reveal="{delay:75}" class="layout-section__title">{{ $t('newsletter.title') }}</h4>
      <p v-if="isComplete">{{ $t('newsletter.complete') }}</p>
      <p v-else-if="hasError">{{ $t('newsletter.error') }}</p>
      <p v-else>{{ $t('newsletter.text') }}</p>

      <div v-if="!isComplete" class="newsletter layout-section__cta">
        <input id="mail" v-model="email" type="email" name="mail" class="newsletter__input" placeholder="e-mail@exemple.com"/>
        <button class="button -light -smaller" :class="{ '-loading': isLoading }" @click="subscribe">{{ $t('newsletter.label') }}</button>
      </div>

      <p v-if="!isValidEmail" class="newsletter__error">{{ $t('newsletter.invalid') }}</p>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HomeNewsletter',
  data() {
    return {
      isComplete: false,
      isLoading: false,
      hasError: false,
      isValidEmail: true,
      email: ''
    }
  },
  methods: {
    subscribe() {
      this.isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
      
      if (this.isLoading || this.isComplete || this.hasError || !this.isValidEmail) return

      this.isLoading = true
      fetch('https://mdooley.medioze.com/?rest_route=/wcd/v1/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.email, lang: this.$i18n.locale })
      })
        .then(response => {
          this.isLoading = false

          if (response.ok) {
            this.isComplete = true
            this.email = ''
          } else {
            this.hasError = true
          }
        }).catch(() => {
          this.isLoading = false
          this.hasError = true
        });
    }
  }
}
</script>
